import {GenericParametersComponent} from './generic-parameters.component';
import { Directive } from "@angular/core";

@Directive()
export abstract class GenericPeriodParametersComponent<T> extends GenericParametersComponent<T> {
    areParametersReadonly(): boolean {
        const context = this.context;
        return context && context.currentSession && context.currentPeriod !== context.currentSession.currentPeriod;
    }
}
